const state = {
    data: [],
    loaded: false,
}
const mutations = {
	SET_PURPOSES(state, purposes) {
        state.data = purposes;
        state.loaded = true;
    },
}
const actions = {
    load({commit}) {
        if (! state.loaded) {
            window.axios.get('purposes')
                .then( ({data}) => commit('SET_PURPOSES', data) );    
        }
    }
}
const getters = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};